import { defineMessages } from 'react-intl'

const HaohaomingSectionMessages = {
  Courses: defineMessages({
    latestCourses: {
      id: 'haohaomingSection.Courses.latestCourses',
      defaultMessage: '最新課程',
    },
    hotCourses: {
      id: 'haohaomingSection.Courses.hotCourses',
      defaultMessage: 'HOT COURSES',
    },
    moreCourses: {
      id: 'haohaomingSection.Courses.moreCourses',
      defaultMessage: '更多課程',
    },
  }),
  Cover: defineMessages({
    exploreCourses: {
      id: 'cover.Cover.exploreCourses',
      defaultMessage: '探索課程',
    },
  }),
}

export default HaohaomingSectionMessages
